export default function emptyTableCells(editor, cells) {
  return editor.withoutNormalizing(function () {
    cells.forEach(function (cell) {
      return editor.emptyTableCell(cell);
    });
  });
}